import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useHeartbeat(groupIdParam) {
  const [stations, setStations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { send, isConnected, registerHandler } = useWebSocketContext();

  const mountedRef = useRef(true);
  const groupId = groupIdParam || localStorage.getItem("group_id");

  // Fetch heartbeat
  const fetchHeartbeat = useCallback(
    async (showLoading = true) => {
      if (!mountedRef.current) return;
      if (showLoading) setIsLoading(true);
      setError("");

      try {
        const response = await send("cms_heartbeat", { group_id: groupId });
        console.log("response for heartbeat ", response)

        if (!mountedRef.current) return;

        if (response?.status === "success") {
          setStations(response.stations || []);
        } else {
          setError("Invalid heartbeat response");
        }
      } catch (err) {
        if (mountedRef.current) setError(err.message || "Heartbeat fetch failed");
      } finally {
        if (mountedRef.current && showLoading) setIsLoading(false);
      }
    },
    [send, groupId]
  );

  // Subscribe to live updates
  useEffect(() => {
    const unregister = registerHandler("heart_beat_user_app_update", (msg) => {
      if (mountedRef.current && msg?.stations) {
        setStations(msg.stations);
      }
    });
    return () => unregister();
  }, [registerHandler]);

  // Initial fetch + re-fetch on reconnect
  useEffect(() => {
    mountedRef.current = true;

    if (isConnected) {
      fetchHeartbeat(true); // fetch immediately when connected
    }

    return () => {
      mountedRef.current = false;
    };
  }, [isConnected, fetchHeartbeat]);

  // Optional polling every 10s
  useEffect(() => {
    if (!isConnected) return;

    const intervalId = setInterval(() => {
      fetchHeartbeat(false); // background fetch, no spinner
    }, 10000);

    return () => clearInterval(intervalId);
  }, [isConnected, fetchHeartbeat]);

  return { stations, isLoading, error, refetch: fetchHeartbeat };
}
